import { useSignal } from '@preact/signals'

import { Typography } from 'components'

const BillingCycleSelector = () => {
	const billingCycle = useSignal<'monthly' | 'yearly'>('monthly')

	return (
		<div>
			<Typography
				text='How often do you want to be billed?'
				variant='h4'
				weight='font-semibold'
			/>
			<Typography
				class='mt-2 text-black-200'
				text='Please specify if your payment plan is set for a recurring term or an extended term.'
				variant='text2'
			/>
			<div class='mt-5 flex min-h-10 items-center gap-10'>
				<button
					class='flex items-center gap-2 text-black-200'
					onClick={() => {
						billingCycle.value = 'monthly'
					}}
					type='button'
				>
					<div
						class={`flex h-4 w-4 items-center justify-center rounded-full ${
							billingCycle.value === 'monthly'
								? 'border-[5px] border-product'
								: 'border-2 border-black-100'
						}`}
					/>
					Monthly
				</button>

				<button
					class='flex items-center gap-2 text-black-200'
					onClick={() => {
						billingCycle.value = 'yearly'
					}}
					type='button'
				>
					<div
						class={`flex h-4 w-4 items-center justify-center rounded-full ${
							billingCycle.value === 'yearly'
								? 'border-[5px] border-product'
								: 'border-2 border-black-100'
						}`}
					/>
					Yearly
				</button>
			</div>
		</div>
	)
}

export { BillingCycleSelector }
